import { Lazy } from '@nrdy-marketing-engine/lazy';
import SeoFooter from './seo-footer';

export default function LazySeoFooter() {
  return (
    <Lazy>
      <SeoFooter />
    </Lazy>
  );
}
